import { createService } from "../../services/serviceFactory";

const updateData = (
  route,
  selectedObject,
  updateDataItem,
  setAllData,
  setUpdateOpenDialog,
  setUpdateIsLoading,
) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    console.log("No token available");
    setUpdateOpenDialog(false);
    setUpdateIsLoading(false);
    return;
  }

  const serviceType = route.split('/').pop();
  const service = createService(serviceType);

  setUpdateIsLoading(true);

  service.update(selectedObject._id, updateDataItem, token)
    .then((updatedItem) => {
      setAllData((prevData) => prevData.map(item =>
        item._id === selectedObject._id ? updatedItem : item
      ));
      // TODO: Success notification
      setUpdateOpenDialog(false);
      setUpdateIsLoading(false);
    })
    .catch((error) => {
      console.log("Update failed:", error);
      setUpdateOpenDialog(false);
      setUpdateIsLoading(false);
    });
};

export default updateData;